import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import React from 'react'

import { BrowserRouter, useLocation } from 'react-router-dom'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client'
import initI18n from './services/i18n'
import { history } from './services/routing'
import { store } from './services/redux'

import { brandName } from './config'

const ConnectedApp = React.lazy(() => {
  return import('./App')
})

const PositionRestore = () => {
  const location = useLocation()
  const [prevLocation, setPrevLocation] = React.useState(location.pathname)

  React.useEffect(() => {
    if (prevLocation !== location.pathname) {
      setPrevLocation(location.pathname)

      if (location.hash && location.hash !== '') {
        setTimeout(() => {
          const id = location.hash.replace('#', '')
          const element = document.getElementById(id)
          if (element) {
            window.scrollTo(0, element.getBoundingClientRect().top + window.pageYOffset - 250)
          }
        }, 0)
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    }
  }, [location, prevLocation])

  return null
}

function Init() {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    initI18n(brandName).then(() => {
      setLoaded(true)
    })
  }, [])
  return loaded ? (
    <React.Suspense fallback={null}>
      <Provider store={store}>
        <BrowserRouter>
          <PositionRestore />
          <React.Fragment>
            <ConnectedApp />
          </React.Fragment>
        </BrowserRouter>
      </Provider>
    </React.Suspense>
  ) : null
}

if (module.hot) {
  module.hot.accept(render)
}

function render() {
  const rootElement = document.getElementById('root')
  ReactDOM.createRoot(rootElement).render(<Init />)
}

render()
